import React,{useEffect} from 'react';
import GuestLayout from '../../../layouts/GuestLayout';
import {
  ContactHero,
  ContactForm,
  ContactInfo,
  ContactFAQ
} from '../../../components/contact';

const ContactUs = () => {
  useEffect(()=>{
    window.scroll(0,0);
  },[])
  return (
    <GuestLayout>
      {/* <ContactHero /> */}
      {/* <ContactForm /> */}
      <ContactInfo />
      <ContactFAQ />
    </GuestLayout>
  );
};

export default ContactUs;